// extracted by mini-css-extract-plugin
export default {"form":"HRvdm2qrANbn0sMXcdJ1","placeHolderShimmer":"ySzrKln0caOH1lBU84Oe"};